// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c480d2f0","453":"80863eb3","644":"a8fb7ecd","732":"b9b8d231"}[chunkId] + ".chunk.js";
};